<div class="cpo-options-shell">
  <div class="cpo-options-grid">
    @for(operator of displayOptions; track operator.key){
      <button
        type="button"
        class="cpo-button"
        [class.cpo-button--selected]="isSelected(operator)"
        (click)="selectOperator(operator)">
        <div class="cpo-icon-frame">
        @if(operator.icon){
          <ion-icon [name]="operator.icon"></ion-icon>
        } @else if (operator.image) {
          <img class="cpo-image" [src]="operator.image" [alt]="operator.label" />
        } @else {
          <ion-icon name="business-outline"></ion-icon>
        }
        </div>
        <ion-text class="cpo-label">
          {{ operator.all ? (operator.label | translate) : operator.label }}
        </ion-text>
      </button>
    }
  </div>
</div>
